<template>
	<el-dialog :visible.sync="visible" title="修改申样备注" width="480px" :before-close="handleClose">
		<el-form ref="form" label-width="50px">
			<el-form-item label="备注">
				<el-input type="textarea" :rows="3" placeholder="请输入内容" maxlength="100" show-word-limit v-model="remark"></el-input>
			</el-form-item>
		</el-form>
		<div slot="footer" class="dialog-footer">
			<el-button @click="visible = false">取 消</el-button>
			<el-button type="primary" @click="submit" :disabled="isDisabled">确 定</el-button>
		</div>
	</el-dialog>
</template>
<script>
import { setSampleRemarkApi } from '@/api/sampleOrder';
export default {
	components: {},
	computed: {},
	watch: {},
	data() {
		return {
			visible: false,
			remark: '',
			sample_sn: '',
			isDisabled: false,
		};
	},
	methods: {
		show({ sample_sn, buyer_remark }) {
			this.sample_sn = sample_sn;
			this.remark = buyer_remark;
			this.visible = true;
		},
		async submit() {
			const { code } = await setSampleRemarkApi({ remark: this.remark, sampleSn: this.sample_sn });
			if (code !== 0) return;
			this.$message.success('修改成功');
			this.$emit('refresh');
			this.handleClose();
		},
		handleClose() {
			this.visible = false;
			this.form = {};
			this.$refs.form.resetFields();
		},
	},
};
</script>
